import { useCallback, useState } from 'react';

// ----------------------------------------------------------------------

export interface BooleanUtil {
  value: boolean;
  onTrue: () => void;
  onFalse: () => void;
  onToggle: () => void;
  setValue: React.Dispatch<React.SetStateAction<boolean>>;
}

export const emptyBooleanUtil: BooleanUtil = {
  value: false,
  onTrue: () => {},
  onFalse: () => {},
  onToggle: () => {},
  setValue: () => {},
};

export function useBoolean(defaultValue?: boolean): BooleanUtil {
  const [value, setValue] = useState(!!defaultValue);

  const onTrue = useCallback(() => {
    setValue(true);
  }, []);

  const onFalse = useCallback(() => {
    setValue(false);
  }, []);

  const onToggle = useCallback(() => {
    setValue((prev) => !prev);
  }, []);

  return {
    value,
    onTrue,
    onFalse,
    onToggle,
    setValue,
  };
}
